import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const UPLOAD_REGISTER_INFO = {
    typeModal: TYPE_MODAL.ACCEPT,
    title: 'Listo! Hemos cargado 56 registros',
    valueButton: 'Ver registro',
    color: CONFIRM_COLOR.SUCCESS,
    iconSVG: 'done'
  };
